import {computed, ComputedRef, Ref, ref} from "vue";
import {Color} from "@k/js/colorObject";
import {useStore} from "vuex";
import {PalettenCluster, PalettenClusterSorted} from "@k/js/databaseInterfaceClasses";
import {ColorViewDataWithOutlineAndPatterns} from "@km/components/color/ColorViewDataWithOutlineAndPatterns";
import {ColorUtilsVue} from "@km/js/ColorUtilsVue";
import {defineStore} from "pinia";




export const useColoreditStore = defineStore("colorEditstatusStore", () => {
    const vuexStore = useStore();
    const colorObjectToEdit = ref(null) as Ref<Color | null>;
    const colorCodes = ref([] as Color[]);
    const activeAreaColorObject = ref(null) as Ref<Color | null>;
    const currentPalettenCluster = ref(null) as Ref<PalettenCluster | null>;
    const currentPalettenClusterSorted = ref(null) as Ref<PalettenClusterSorted | null>;
    const visibleColorObjectsExcludingOutlines: ComputedRef<ColorViewDataWithOutlineAndPatterns[]> = computed(() => colorCodes.value
        .filter(c => c.isVisible && !c.isOutlineColorCode() && !(c.colorCodeToDisplay !== c.colorCode))
        .map(c => new ColorViewDataWithOutlineAndPatterns(c, getOutlineColorValueForMainColor(c.colorCode)))
    );

    const outlineColorObjectForCurrentColorObject: ComputedRef<Color | null> = computed(() => {
        if (activeAreaColorObject.value === null) {
            return null;
        }
        return colorCodes.value.find(c => c.colorCodeToDisplay === (activeAreaColorObject.value as Color).colorCodeToDisplay + "_O" && c.isVisible) || null;
    });


    function getOutlineColorValueForMainColor(mainColorCode: string): number | null {
        const outlineColor = colorCodes.value.find(c => c.colorCodeToDisplay === mainColorCode + "_O" && c.isVisible);
        if (!outlineColor) {
            return null;
        }
        return outlineColor.colorValue;
    }


    function initColorsEventHandler(store:any, colorCodesToSet: Color[]) {
        colorCodes.value = [];
        colorCodes.value = colorCodesToSet;
        store.dispatch("loadPalettenClusters", getPalettenClusterToLoad())
    }

    function getPalettenClusterToLoad() {
        return colorCodes.value.map(colorCode => colorCode.palettenCluster)
            .reduce(function (carry, pc) {
                if (carry.indexOf(pc) === -1) {
                    carry.push(pc);
                }
                return carry;
            }, [] as string[]);
    }


    function setColorObjectToEdit(colorcode: string|null) {

        if(colorcode === null) {
            colorObjectToEdit.value = null;
            currentPalettenCluster.value = null;
            currentPalettenClusterSorted.value = null;
            return;
        }
        const found = colorCodes.value.find(c => c.colorCode === colorcode);
        colorObjectToEdit.value = null;
        if (found !== undefined) {
            colorObjectToEdit.value = found;
            if (found.palette === null || found.palette === "") {
                found.palette = ColorUtilsVue.getPaletteForColorValueFromCluster(found.colorValue, getActivePalettenCluster())
            }
        }
        currentPalettenCluster.value = getActivePalettenCluster();
        currentPalettenClusterSorted.value = getActivePalettenClusterSorted(currentPalettenCluster.value)

    }

    const getActivePalettenCluster=  () => colorObjectToEdit.value === null ?
        null :
        vuexStore.getters.getPalettenCluster(colorObjectToEdit.value.palettenCluster);

    const getActivePalettenClusterSorted = (palettenCluster: PalettenCluster | null) => palettenCluster === null ?
        null :
        vuexStore.getters.getPalettenClusterSorted(palettenCluster)


    return {
        currentColorValueIntOrNONEstring:computed(()=>colorObjectToEdit.value === null ? "" : colorObjectToEdit.value.colorValue.toString()),
        currentPalette:computed(()=> {
            return colorObjectToEdit.value === null ? "" : (colorObjectToEdit.value as Color).palette
        }),
        setActiveAreaColorObject:(colorObject:Color) => activeAreaColorObject.value = colorObject,
        getActivePalettenCluster: () => colorObjectToEdit.value === null ? null : vuexStore.getters.getPalettenCluster(colorObjectToEdit.value.palettenCluster),
        getActivePalettenClusterSorted :(palettenCluster: PalettenCluster | null) => palettenCluster === null ? null : vuexStore.getters.getPalettenClusterSorted(palettenCluster),
        getOutlineColorValueForMainColor,
        setColorObjectToEdit,
        colorCodes:computed(()=>colorCodes.value),
        colorObjectToEdit:computed(()=>colorObjectToEdit.value),
        activeAreaColorObject:computed(()=>activeAreaColorObject.value),
        currentPalettenCluster:computed(()=>currentPalettenCluster.value),
        currentPalettenClusterSorted:computed(()=>currentPalettenClusterSorted.value),
        getColor:(colorCode:string)=>colorCodes.value.find(c=>c.colorCode === colorCode),
        reset:()=>{
            colorObjectToEdit.value = null;
            activeAreaColorObject.value = null;
            currentPalettenCluster.value = null;
            currentPalettenClusterSorted.value = null;
        },
        getCurrentColorCode :computed(() => colorObjectToEdit.value === null ? "" : (colorObjectToEdit.value as Color).colorCode),
        initColorsEventHandler,
        getPalettenClusterToLoad:()=>{
            return colorCodes.value.map(colorCode => colorCode.palettenCluster)
                .reduce(function (carry, pc) {
                    if (carry.indexOf(pc) === -1) {
                        carry.push(pc);
                    }
                    return carry;
                }, [] as string[]);
        },
        visibleColorObjectsExcludingOutlines:computed(()=>visibleColorObjectsExcludingOutlines.value),
        getOutlineForActiveAreaColorObject:computed(()=>outlineColorObjectForCurrentColorObject.value),
    }


})